/**
 ** module: LoadPOAData.js
 ** usage: utility to load POA data into Snow Application
 ** created: 11/30/2025
 ** owner: Rob Blanch
 **/
import React from 'react';
import {withRouter} from 'react-router-dom';
import SLTHeaderNavBar from './SLTHeaderNavBar.js';
import FormMessage from './FormMessage.js';
import SLTFileLoadDropZoneControl from './SLTFileLoadDropZoneControl.js';
import SLTSubmitControl from './SLTSubmitControl.js';
import SLTSnowAppErrHelper from './SLTSnowAppErrHelper.js';

/**
 * class: LoadPOAData
 * usage: used to provide admin user ability to load POA data into Snow Application
 * props:
 *      logoItem - logo information to display in nav header of form
 *      isNavBarExpanded - true/false flag indicating if nav bar menu should be expanded
 *      setNavBarExpanded(newExpandState) - callback to alter state of isNavBarExpanaded to newExpandState value
 *      loadLotData(onComplete, onError, neighborhood, lotDataFilename) - callback routine to load lot POA data into system
 *      loadOwnerData(onComplete, onError, neighborhood, lotOwnerFilename) - callback routine to load owner POA data into system
 */
class LoadPOAData extends React.Component {
    constructor(props) {
        var msg;
        var err;

        super(props);

        this.state = {
            error: null,
            message: null,
            user_key: null,
            lotdata_file: '',
            ownerdata_file: '',
        };

        this.handleChange = this.handleInputChange.bind(this);
        this.handleLoadData = this.handleLoadData.bind(this);

        if (this.props.loadLotData === undefined || this.props.loadLotData === null) {
            msg = 'LoadPOAData: loadLotData prop not provided, cannot continue';
            err = new Error(msg);
            this.setState({error: err, message: msg});
        }
        
        if (this.props.loadOwnerData === undefined || this.props.loadOwnerData === null) {
            msg = 'LoadPOAData: loadOwnerData prop not provided, cannot continue';
            err = new Error(msg);
            this.setState({error: err, message: msg});
        }
    }

    /**
     * componentDidMount
     *      react js routine called right before component mounts
     */
    componentDidMount()
    {
    }

    /**
     * handleInputChange
     *      routine to maintain state relative to user edits in UI
     */
    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    /**
     * handleLoadData
     *      load data into POA system
     */
    handleLoadData(event) {
        const DefaultNeighborhood = 'Golden Bear Reserve';
        const lotDataFilename = this.state.lotdata_file;
        const ownerDataFilename = this.state.ownerdata_file;

        event.preventDefault();

        if (lotDataFilename !== '') {
            this.props.loadLotData(
                (message) => {
                    if (ownerDataFilename !== '') {
                        this.props.loadOwnerData(
                            (ownerMessage) => {
                                this.setState({message: message + ' ' + ownerMessage});
                            },
                            (ownerError) => {
                                var appErrHelper = new SLTSnowAppErrHelper();
                                const errMsg = appErrHelper.getUserErrMsgFromError(ownerError);
                                this.setState({message: errMsg, error: ownerError});
                            },
                            DefaultNeighborhood,
                            ownerDataFilename
                        );
                    }
                },
                (error) => {
                    var appErrHelper = new SLTSnowAppErrHelper();
                    const errMsg = appErrHelper.getUserErrMsgFromError(error);
                    this.setState({message: errMsg});
                },
                DefaultNeighborhood,
                lotDataFilename
            );
        } else if (ownerDataFilename !== '') {
            this.props.loadOwnerData(
                (ownerMessage) => {
                    this.setState({message: ownerMessage});
                },
                (ownerError) => {
                    var appErrHelper = new SLTSnowAppErrHelper();
                    const errMsg = appErrHelper.getUserErrMsgFromError(ownerError);
                    this.setState({message: errMsg, error: ownerError});
                },
                DefaultNeighborhood,
                ownerDataFilename
            );
        } else {
            this.setState({message: 'Please provide at least one data file to load.'});
        }
    }

    /**
     * render
     *      routine called by react js to layout UI
     */
    render() {
        const error = this.state.error;
        const message = this.state.message;
        const navItems = [
            {link:'#',label:'Load POA Data',icon:null,onclick:() => {return this.handleLoadData()}},
            {link:'/account',label:'Account',icon:null}
        ];

        return(
            <React.StrictMode>
            <SLTHeaderNavBar    props
                                logoItem={this.props.logoItem}
                                navItems={navItems}
                                isNavBarExpanded={this.props.isNavBarExpanded}
                                setNavBarExpanded={this.props.setNavBarExpanded} />
            <form onSubmit={this.handleLoadData} style={{"paddingTop":"75px"}}>
                <table className="Page_Table" name="LoadPOADataTable" align="center">
                    <tbody>
                    <tr>
                        <td>
                            <FormMessage error={error} message={message} />
                        </td>
                    </tr>

                    <SLTFileLoadDropZoneControl props
                                            key="lotdata_file"
                                            name="lotdata_file"
                                            label="Lots:"
                                            onFileLoad={(fileContent) => {this.setState({lotdata_file: fileContent});}} />

                    <SLTFileLoadDropZoneControl props
                                            key="ownerdata_file"
                                            name="ownerdata_file"
                                            label="Owners:"
                                            onFileLoad={(fileContent) => {this.setState({ownerdata_file: fileContent});}} />
                    <SLTSubmitControl  props
                                    value="Load POA Data"
                                    name="submit_loadpoadata"
                                    onClick={this.handleLoadData} />
                    </tbody>
                </table>
            </form>
            </React.StrictMode>
        );
    }
}  

export default withRouter(LoadPOAData);